import { render, staticRenderFns } from "./investmentInfo.vue?vue&type=template&id=1128d4d7&scoped=true"
import script from "./investmentInfo.vue?vue&type=script&lang=js"
export * from "./investmentInfo.vue?vue&type=script&lang=js"
import style0 from "./investmentInfo.vue?vue&type=style&index=0&id=1128d4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1128d4d7",
  null
  
)

export default component.exports